import type { SystemStyleObject } from "@ui/types";

export const styles = {
    policyCheckBox: {
        padding: "0 !important",
        _hover: {
            borderRadius: 1,
            borderWidth: 1,
            borderColor: "white",
        },
        mt: "1",
        borderRadius: 1,
        borderWidth: 1,
        bg: "transparent",
    },
    policyLabel: {
        m: 0,
        pt: [0, 1],
        color: "white",
        sx: {
            "& p": {
                m: 0,
                textAlign: "left",
                color: "white",
                fontSize: ["mobileBodyTextNormal", "desktopBodyTextNormal"],
                fontWeight: "bold",
            },
            "& span": {
                m: 0,
                color: "black",
                fontSize: ["mobileBodyTextNormal", "desktopBodyTextNormal"],
                fontWeight: "bold",
            },
        },
    },
    flex: {
        alignItems: "center",
        gap: 3,
        mt: [2, 6],
    },
    errorMessage: {
        color: "errorOnBlack",
        mt: 0,
    },
    errorBox: {
        height: 4,
    },
    text: {
        color: "white",
    },
} satisfies Record<string, SystemStyleObject>;
